{
  "customer-selection-form": {
    "buttons": {
      "close": "Close",
      "create_new_customer_profile": "Create new",
      "select": "Select",
      "selected": "Selected"
    },
    "text": {
      "search_field_label": "Search by phone number, email or name",
      "title": "Customer selection"
    }
  }
}
